import {
  Box,
  Card,
  CardActionArea,
  CardMedia,
  Fade,
  Grid,
  IconButton,
  Typography,
  useTheme,
} from "@mui/material";
import { catalogs } from "../../helpers/Catalog";
import { useEffect, useRef, useState } from "react";
import { useLenis } from "../../hooks/useLenis";
import gsap from "gsap";
import { addToRefsGeneric } from "../../utils/funtions";
import { Pause, Play } from "../../icons";

export const Catalog = () => {
  useLenis(1);

  const theme = useTheme();
  const boxVideoRef = useRef<HTMLDivElement>(null);
  const titleRef = useRef<HTMLDivElement>(null);
  const cardRef = useRef<HTMLDivElement[]>([]);

  const addCardRef = addToRefsGeneric(cardRef);

  const videoRef = useRef<HTMLVideoElement>(null);

  const [video, setVideo] = useState(true);
  const onSecondVideo = () => {
    if (videoRef.current) {
      if (video) {
        setVideo(false);
        videoRef.current.pause();
      } else {
        setVideo(true);
        videoRef.current.play();
      }
    }
  };

  useEffect(() => {
    const ctx = gsap.context(() => {
      if (!titleRef.current) return;
      gsap.fromTo(
        titleRef.current,
        { opacity: 0, y: 90, transformPerspective: 1000, rotateX: 0.01 },
        {
          opacity: 1,
          y: 0,
          ease: "power1.out",
          scrollTrigger: {
            trigger: titleRef.current,
            start: "top top+=200",
            end: "bottom bottom",
            once: true,
          },
        }
      );

      if (!boxVideoRef.current) return;
      gsap.fromTo(
        boxVideoRef.current,
        { scale: 1, borderRadius: 0 },
        {
          scale: 0.95,
          ease: "none",
          borderRadius: 30,

          scrollTrigger: {
            trigger: boxVideoRef.current,
            start: "top top+=150",
            end: "+=200",
            scrub: 0.5,
          },
        }
      );

      if (!cardRef.current) return;

      cardRef.current.forEach((el, i) => {
        gsap.fromTo(
          el,
          { opacity: 0, y: 100, transformPerspective: 1000, rotateX: 0.01 },
          {
            opacity: 1,
            y: 0,
            ease: "power1.out",
            delay: i * 0.1,
            scrollTrigger: {
              trigger: el,
              start: "top 95%",
              end: "bottom bottom",
              once: true,
            },
          }
        );
      });
    });
    return () => ctx.revert();
  }, []);

  return (
    <Box>
      <Box
        ref={titleRef}
        marginBlock={8}
        width="100%"
        display="flex"
        flexDirection={{ sm: "row", xs: "column" }}
        justifyContent={{ sm: "space-between" }}
        alignItems={{ xs: "flex-start" }}
      >
        <Typography
          sx={{
            marginInline: { xs: 3, md: 8 },
            fontSize: { xs: 30, sm: 35, md: 40 },
            fontWeight: 800,
            textAlign: "center",
            background: `linear-gradient(50deg, ${theme.palette.secondary[900]} , ${theme.palette.secondary[300]} 70%)`,
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
          }}
        >
          Catalogs
        </Typography>
        <Typography
          sx={{
            marginInline: { xs: 3, md: 8 },
            fontSize: { xs: 15, sm: 20, md: 25 },
            fontWeight: 600,
             maxWidth: 200,
            textAlign: "center",
            color: theme.palette.secondary[100],
          }}
        >
          Excellence in Dance
        </Typography>
      </Box>

      <Box
        position="relative"
        ref={boxVideoRef}
        width="100%"
        overflow="hidden"
        height={{ xs: 250, sm: 450, md: 650 }}
      >
        <Fade in timeout={1500}>
          <video
            ref={videoRef}
            poster="https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/catalog/hero/poster.jpgg"
            src="https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/catalog/hero/catalog.mp4"
            autoPlay={true}
            loop={true}
            muted
            playsInline
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
          />
        </Fade>

        <Box
          position="absolute"
          bottom={{ xs: 20, md: 60 }}
          zIndex={99}
          right={{ xs: 20, md: 60 }}
        >
          <IconButton
            onClick={onSecondVideo}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: { xs: 30, md: 40 },
              height: { xs: 30, md: 40 },
              backdropFilter: "saturate(180%) blur(5px)",
              backgroundColor: theme.palette.background.paper,
              borderRadius: "100vmax !important",
              "&:hover": {
                backgroundColor: theme.palette.background.paper,
              },
            }}
          >
            {!video ? (
              <Play
                sx={{ width: { xs: 15, md: 19 }, height: { xs: 15, md: 19 } }}
              />
            ) : (
              <Pause
                sx={{ width: { xs: 15, md: 19 }, height: { xs: 15, md: 19 } }}
              />
            )}
          </IconButton>
        </Box>
      </Box>

      <Grid
        container
        spacing={{ xs: 3, md: 4 }}
        mt={5}
        marginInline={{ xs: 2, md: 10 }}
        mb={10}
      >
        {catalogs.map((c) => (
          <Grid ref={addCardRef} key={c.id} size={{ xs: 6, md: 4 }}>
            <a href={c.document} rel="noreferrer" target="_blank">
              <Card
                sx={{
                  scale: 1,
                  transition: "scale 0.3s ease",
                  "&:hover": { scale: 1.01 },
                  height: "100%",
                  boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
                  borderRadius: 3,
                }}
                elevation={0}
              >
                <CardActionArea sx={{ height: "100%" }}>
                  <CardMedia
                    sx={{ height: "100%" }}
                    component="img"
                    src={c.portada}
                    alt="portada"
                  />
                </CardActionArea>
              </Card>
            </a>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};
